
/* ----------------------------------
   Allowed Types & Extensions
----------------------------------- */

import { MAX_FILE_UPLOAD_PER_QUERY, MAX_TOTAL_FILE_UPLOAD_SIZE_PER_QUERY } from "./constant";

export const allowedTypes = [
  "application/pdf",
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
  "text/html",
  "application/python",
  "text/x-python",
  "application/x-python",
  "application/sql",
  "image/jpeg",
  "image/png",
];

export const extensions = [
  ".pdf",
  ".csv",
  ".xls",
  ".xlsx",
  ".txt",
  ".html",
  ".py",
  ".sql",
  ".jpg",
  ".jpeg",
  ".png",
  ".docx",
];

export const acceptString = [...extensions, ...allowedTypes].join(",");

/* ----------------------------------
   Validation Function
----------------------------------- */

export const validateFiles = (newFiles, existingFiles = []) => {
  // 1️⃣ Extension validation
  const invalidExtension = newFiles.some((file) => {
    const ext = "." + file.name.split(".").pop()?.toLowerCase();
    return !extensions.includes(ext);
  });

  if (invalidExtension) {
    return "Invalid file type. Only supported files are allowed.";
  }

  // 2️⃣ File count limit
  const totalFileInputLimit = MAX_FILE_UPLOAD_PER_QUERY;

  const totalFiles = existingFiles.length + newFiles.length;

  if (totalFiles > totalFileInputLimit) {
    return `You can upload a maximum of ${totalFileInputLimit} files.`;
  }

  // 3️⃣ Total size limit
  const totalFileUploadSizeLimit = MAX_TOTAL_FILE_UPLOAD_SIZE_PER_QUERY; // in MB

  const totalSize =
    existingFiles.reduce((acc, file) => acc + file.size, 0) +
    newFiles.reduce((acc, file) => acc + file.size, 0);

  if (totalSize > totalFileUploadSizeLimit * 1024 * 1024) {
    return `Total file size should not exceed ${totalFileUploadSizeLimit} MB.`;
  }

  return null;
};
